/* 🤖 this file was generated by svg-to-ts */
export const svgArrowDown: {
    name: "arrow-down";
    data: string;
} = {
    name: "arrow-down",
    data: '<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__arrow-down" viewBox="0 0 24 24"><path fill="none" stroke="#000" stroke-width="3" d="M 3,9 12,18 21,9"/></symbol></svg>',
};
